//basic
import React from 'react'
import { toJS } from 'mobx'
import { observer, inject } from 'mobx-react'

//api
import { api } from '../../../functions/api'

//custom components
import CustomInput from '../../../components/basic/input'
import CustomButton from '../../../components/basic/CustomButton'
import SelectSearch from '../../../components/basic/SelectSearch/SelectSearch'
import CustomAvatar from '../../../components/basic/customAvatar';

//material-ui
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    Button,
    ListItem,
    CircularProgress,
    Grid,
    MuiThemeProvider,
    createMuiTheme
} from '@material-ui/core'
// import { DateTimePicker } from 'material-ui-pickers'
// import { IconButton, InputAdornment } from '@material-ui/core'
// import CalendarToday from '@material-ui/icons/CalendarToday'

//style
import './AddEditItem.scss'

//other libraries

import image from '../../../assets/image/svg/logo.svg';

const materialTheme = createMuiTheme({
    typography: {
        useNextVariants: true
    },
    overrides: {
        MuiInput: {
            underline: {
                '&::after': {
                    borderBottomColor: '#777777',
                    borderBottom: '2px solid #777777 !important'
                }
            },
            disabled: {
                '&::before': {
                    borderBottom: '1px solid #777777 !important'
                }
            }
        },
        MuiDialogActions: {
            root: {
                overflow: 'initial'
            }
        },
        MuiDialogContent: {
            root: {
                overflow: 'auto'
            }
        },
        MuiDialog: {
            paper: {
                overflow: 'initial',
                overflowY: 'initial'
            }
        }
    }
})

@inject('translate')
@inject('internal')
@observer
export default class AddEditItem extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            listProducts: [],
            listStaticSets: [],
            selectedProducts: [],
            selectedStaticSets: [],
            image: null,
            production: false,
        }
    }

    componentDidMount() {
        this.reformatProductsAndStaticSets()
        let isEditMode = toJS(this.props.internal.actionEdit)
        if (isEditMode.edit) {
            this.setState({ loading: true })
            this.loadGift(isEditMode.id)
        }
    }

    reformatProductsAndStaticSets() {
        const { products, static_sets } = toJS(this.props.internal.dataForTable.lists)

        let tmpProducts = products.map((item) => {return {label: `${item.code} - ${item.name}`, value: item.id};});
        let tmpStaticSets = static_sets.map((item) => {return {label: item.name, value: item.id};});

        this.setState({ listProducts: tmpProducts, listStaticSets: tmpStaticSets })
    }

    loadGift = async (id) => {
        let load_data = await api({
            url: `products/gifts/${id}`,
            method: 'get',
            authorization: this.props.internal.user.access_token,
        })

        if(load_data.success === true) {
            this.setState({loading: false, production: load_data.data.data.production});
            this.name.setValue(load_data.data.data.name);
            this.price_from.setValue(load_data.data.data.price_from);
            this.description.setValue(load_data.data.data.description);
            this.photo = load_data.data.data.photo;

            let tmpProducts = load_data.data.data.products.map((item) => {return {label: `${item.code} - ${item.name}`, value: item.id};});
            let tmpStaticSets = load_data.data.data.static_sets.map((item) => {return {label: item.name, value: item.id};});

            this.setState({selectedProducts: tmpProducts, selectedStaticSets: tmpStaticSets});
        }
    }

    photo = ""

    action = () => {
        let name = this.name.state.value
        let price_from = this.price_from.state.value
        let description = this.description.state.value

        if(name !== "" && price_from !== "" && description !== "") {
            if (toJS(this.props.internal.actionEdit.edit)) {
                this.updateGift()
            } else {
                this.createNewGift()
            }
        }
        else {
            this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.FILL_REQUIRED_INPUTS, true)
        }
    }

    updateGift = async () => {

        let id = toJS(this.props.internal.actionEdit.id)
        this.setState({loadingBtn: true})

        let create_data = await api({
            method: 'patch',
            url: `products/gifts/${id}`,
            authorization: this.props.internal.user.access_token,
            //TODO: vymazat
            // postman: true,
            params: {
                name: this.name.state.value,
                price_from: this.price_from.state.value,
                shop_id: this.props.shop_id,
                description: this.description.state.value,
                production: this.state.production
            }
        })

        if(create_data.success === true || (create_data.success === false && create_data.status === 201)) {
            if(this.state.image !== null) {
                this.updateImage(id)
            }
            await this.setProducts(id);
            await this.setStaticSets(id);
            this.setState({loadingBtn: false})
            this.props.onClose(true)
        }

    }

    createNewGift = async () => {
        this.setState({loadingBtn: true})

        let create_data = await api({
            method: 'post',
            url: 'products/gifts',
            authorization: this.props.internal.user.access_token,
            //TODO: vymazat
            // postman: true,
            params: {
                name: this.name.state.value,
                price_from: this.price_from.state.value,
                shop_id: this.props.shop_id,
                description: this.description.state.value,
                production: this.state.production
            }
        })

        if(create_data.success === true || (create_data.success === false && create_data.status === 201)) {
            if(this.state.image !== null) {
                this.updateImage(create_data.data.data.id)
            }
            await this.setProducts(create_data.data.data.id)
            await this.setStaticSets(create_data.data.data.id)
            this.setState({loadingBtn: false})
            this.props.onClose(true)

        }
    }

    updateImage = async(id) => {
        let update_image = await api({
            method: 'POST',
            url: `products/gifts/${id}`,
            authorization: this.props.internal.user.access_token,
            //TODO: vymazat
            // postman: true,

            formData: true,
            params: {
                photo: this.state.image
            }
        })
    }

    setProducts = async(id) => {
        let products = this.state.selectedProducts
        let ids = products.map(item => Number(item.value))
        let set_products = await api({
            method: 'patch',
            url: `products/gifts/${id}/pair-products`,
            //TODO: vymazat
            // postman: true,
            authorization: this.props.internal.user.access_token,
            params: {
                ids: ids
            }
        })

        if(set_products.success === true) {
            this.props.internal.setSnackbar(set_products.data.message, true)
        }
    }

    setStaticSets = async(id) => {
        let staticSets = this.state.selectedStaticSets;
        let ids = staticSets.map(item => Number(item.value))
        let response = await api({
            method: 'patch',
            url: `products/gifts/${id}/pair-static-sets`,
            authorization: this.props.internal.user.access_token,
            params: {
                ids: ids
            }
        })

        if(response.success === true) {
            this.props.internal.setSnackbar(response.data.message, true)
        }
    }

    handleChangeCheckbox = event => {
        this.setState({ production: event.target.checked })
    }

    handleAddProduct = val => {
        this.setState({ selectedProducts: val })
    }

    handleAddStaticSet = val => {
        this.setState({ selectedStaticSets: val })
    }

    handleChangePhoto = (data) => {
        this.setState({image: data})
        return Promise.resolve(false)
        // this.props.internal.photoWasChanged(false)
    }

    render() {
        return (
            <MuiThemeProvider theme={materialTheme}>
                <Dialog
                    open={this.props.open}
                    scroll={'paper'}
                    onClose={() => this.props.onClose(false)}
                    aria-labelledby='form-dialog-title'
                    classes={{
                        paper: 'addEditGiftDialog'
                    }}
                >
                    <DialogTitle id='form-dialog-title'>{this.props.title}</DialogTitle>
                    {this.state.loading ? (
                        <DialogContent>
                            <CircularProgress className={'circular-progress'} />
                        </DialogContent>
                    ) : (
                        <DialogContent>
                            <div className={'giftImage'}>
                                <CustomAvatar
                                    src={this.photo !== '' ? this.photo : image}
                                    actionUploadPhoto={this.handleChangePhoto}
                                />
                            </div>
                            <div className={'name-price'}>
                                <CustomInput
                                    ref={ref => (this.name = ref)}
                                    text={this.props.translate.i18n.MODULES.GIFTS.NAME}
                                    value=''
                                    id={'name'}
                                    required
                                />
                                <CustomInput
                                    ref={ref => (this.price_from = ref)}
                                    text={this.props.translate.i18n.MODULES.GIFTS.PRICE_FROM}
                                    value=''
                                    id={'price_from'}
                                    className={'text-right w-50'}
                                    required
                                    endAdornment={{ position: 'end', value: '€' }}
                                />
                            </div>
                            <CustomInput
                                ref={ref => (this.description = ref)}
                                text={this.props.translate.i18n.MODULES.GIFTS.DESCRIPTION}
                                // value={this.props.idCategory ? this.editCategory.name : ""}
                                value=''
                                id={'description'}
                                className={'w-100'}
                                multiline={true}
                                required
                            />

                            <SelectSearch
                                options={this.state.listProducts}
                                onChange={val => this.handleAddProduct(val)}
                                value={this.state.selectedProducts}
                                isMulti={true}
                                className={'select-search'}
                                label={this.props.translate.i18n.MODULES.GIFTS.PRODUCTS}
                                // menuIsOpen
                                // onMenuOpen={this.handleScrollDown}
                            />

                            <SelectSearch
                                options={this.state.listStaticSets}
                                onChange={val => this.handleAddStaticSet(val)}
                                value={this.state.selectedStaticSets}
                                isMulti={true}
                                className={'select-search'}
                                label={this.props.translate.i18n.MODULES.GIFTS.FIXED_SETS}
                                // menuIsOpen
                                // onMenuOpen={this.handleScrollDown}
                            />
                            <ListItem
                                dense
                                onChange={this.handleChangeCheckbox}
                                className={'list-item'}
                            >
                                <input
                                    id={'production'}
                                    type='checkbox'
                                    value={'production'}
                                    defaultChecked={this.state.production}
                                />
                                <label htmlFor={'production'}>
                                    {this.props.translate.i18n.GLOBAL.TABLE.ACTIVE}
                                </label>
                            </ListItem>
                        </DialogContent>
                    )}
                    <DialogActions>
                        <Button onClick={() => this.props.onClose(false)} className={'gray-text'}>
                            {this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                        </Button>
                        <CustomButton
                            progressBar={this.state.loadingBtn}
                            onClick={this.action}
                            mystyle={'btn-white-bg'}
                            title={this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
                            justText
                            disabled={this.state.loading}
                        />
                    </DialogActions>
                </Dialog>
            </MuiThemeProvider>
        )
    }
}



// WEBPACK FOOTER //
// ./src/screens/gifts/AddEditItem/AddEditItem.jsx